import React from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";

const StatCard = ({ title, value, icon, subtitle, color }) => (
  <Paper
    elevation={1}
    sx={{
      p: 2.5,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "grey.200",
      display: "flex",
      flexDirection: "column",
      gap: 1,
      height: "100%",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          p: 1,
          borderRadius: 1.5,
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
      {subtitle && (
        <Chip
          size="small"
          label={subtitle}
          color="success"
          variant="outlined"
          sx={{ fontSize: 10 }}
        />
      )}
    </Box>
    <Box>
      <Typography
        variant="caption"
        sx={{
          textTransform: "uppercase",
          color: "text.secondary",
          fontWeight: 600,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        sx={{ mt: 0.5, fontWeight: 800, color: color || "text.primary" }}
      >
        {value}
      </Typography>
    </Box>
  </Paper>
);

export default StatCard;
